import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Dashboard from "./pages/Dashboard/Dashboard";
import CardsWithStripe from "./pages/Cards/CardsWithStripe";
import Transactions from "./pages/Transactions/transactions";
import Navbar from "./components/Navbar/Navbar";
import PrivateRoute from "./components/PrivateRoute";
import EmailVerificationBanner from "./components/EmailVerificationBanner/EmailVerificationBanner";
import ForgetPassword from "./pages/forgetPassword/forgetPassword";
import ChangePasswordForm from "./pages/Password/Password";
import { useAuthStatus } from "./hooks/useAuthState";

function App() {
  const { loggedIn, emailVerified, userEmail, refreshAuth } = useAuthStatus();

  return (
    <Router>
      <Navbar />

      {loggedIn && !emailVerified && (
        <EmailVerificationBanner userEmail={userEmail} onRefresh={refreshAuth} />
      )}

      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/forgetPassword" element={<ForgetPassword />} />

        <Route path="/dashboard" element={<PrivateRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>
        <Route path="/transactions" element={<PrivateRoute />}>
          <Route path="/transactions" element={<Transactions />} />
        </Route>
        <Route path="/cards" element={<PrivateRoute />}>
          <Route path="/cards" element={<CardsWithStripe />} />
        </Route>
        <Route path="/changepassword" element={<PrivateRoute />}>
          <Route path="/changepassword" element={<ChangePasswordForm />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
